export const terminologies = [
  {
    norwegian: "Treningshall",
    korean: "Do jang",
    belt: "10-gup"
  },
  {
    norwegian: "Treningsdrakt",
    korean: "Do bok",
    belt: "10-gup"
  },
  {
    norwegian: "Gi oppmerksomhet",
    korean: "Charyot",
    belt: "10-gup"
  },
  {
    norwegian: "Hils (bukk)",
    korean: "Kyong ye",
    belt: "10-gup"
  },
  {
    norwegian: "Klar",
    korean: "Jun bi",
    belt: "10-gup"
  },
  {
    norwegian: "Parallell",
    korean: "Narani",
    belt: "10-gup"
  },
  {
    norwegian: "Start",
    korean: "Shi jak",
    belt: "10-gup"
  },
  {
    norwegian: "Skrik",
    korean: "Kihap",
    belt: "10-gup"
  },
  {
    norwegian: "Tilbake til utgangspunkt",
    korean: "Parou",
    belt: "10-gup"
  },
  {
    norwegian: "Slapp av",
    korean: "Swiyo",
    belt: "10-gup"
  },
  {
    norwegian: "Tre av",
    korean: "Hae san",
    belt: "10-gup"
  },
  {
    norwegian: "Stilling",
    korean: "Sogi",
    belt: "10-gup"
  },
  {
    norwegian: "Sittestilling",
    korean: "Annun sogi",
    belt: "10-gup"
  },
  {
    norwegian: "Gå-stilling",
    korean: "Gunnun sogi",
    belt: "10-gup"
  },
  {
    norwegian: "Punch",
    korean: "Jirugi",
    belt: "10-gup"
  },
  {
    norwegian: "Blokk",
    korean: "Makgi",
    belt: "10-gup"
  },
  {
    norwegian: "Spark",
    korean: "Chagi",
    belt: "10-gup"
  },
  {
    norwegian: "Lav",
    korean: "Najunde",
    belt: "10-gup"
  },
  {
    norwegian: "Middels",
    korean: "Kaunde",
    belt: "10-gup"
  },
  {
    norwegian: "Høy",
    korean: "Nopunde",
    belt: "10-gup"
  },
  {
    norwegian: "Rett",
    korean: "Baro",
    belt: "10-gup"
  },
  {
    norwegian: "Front",
    korean: "Ap",
    belt: "10-gup"
  },
  {
    norwegian: "Side",
    korean: "Yop",
    belt: "10-gup"
  },
  {
    norwegian: "Innsiden",
    korean: "An",
    belt: "10-gup"
  },
  {
    norwegian: "Underarm",
    korean: "Palmok",
    belt: "10-gup"
  },
  {
    norwegian: "Knivhånd",
    korean: "Sonkal",
    belt: "10-gup"
  },
  {
    norwegian: "Knivfot",
    korean: "Balkal",
    belt: "10-gup"
  },
  {
    norwegian: "Knyttneve",
    korean: "Joomuk",
    belt: "10-gup"
  },
  {
    norwegian: "Hånd",
    korean: "Son",
    belt: "10-gup"
  },
  {
    norwegian: "Fot",
    korean: "Bal",
    belt: "10-gup"
  },
  {
    norwegian: "Oppadstigende",
    korean: "Olligi",
    belt: "10-gup"
  },
  {
    norwegian: "Firevending",
    korean: "Saju",
    belt: "10-gup"
  },
  {
    norwegian: "Selvforsvar",
    korean: "Ho sin sul",
    belt: "10-gup"
  },
  {
    norwegian: "Sparring",
    korean: "Matsogi",
    belt: "10-gup"
  },
  {
    norwegian: "Ass. instr. (1. - 3. Dan)",
    korean: "Boo sabumnim",
    belt: "10-gup"
  },
  {
    norwegian: "Instruktør (4. - 6. Dan)",
    korean: "Sabumnim",
    belt: "10-gup"
  },
  {
    norwegian: "Master (7. - 8. Dan)",
    korean: "Sahyunnim",
    belt: "10-gup"
  },
  {
    norwegian: "Grand master (9. Dan)",
    korean: "Sasungnim",
    belt: "10-gup"
  },
  {
    norwegian: "En",
    korean: "Hana",
    belt: "10-gup"
  },
  {
    norwegian: "To",
    korean: "Dul",
    belt: "10-gup"
  },
  {
    norwegian: "Tre",
    korean: "Set",
    belt: "10-gup"
  },
  {
    norwegian: "Fire",
    korean: "Net",
    belt: "10-gup"
  },
  {
    norwegian: "Fem",
    korean: "Dasot",
    belt: "10-gup"
  },
  {
    norwegian: "Seks",
    korean: "Yosot",
    belt: "10-gup"
  },
  {
    norwegian: "Sju",
    korean: "Ilgop",
    belt: "10-gup"
  },
  {
    norwegian: "Åtte",
    korean: "Yodul",
    belt: "10-gup"
  },
  {
    norwegian: "Ni",
    korean: "Ahop",
    belt: "10-gup"
  },
  {
    norwegian: "Ti",
    korean: "Yol",
    belt: "10-gup"
  },
  {
    norwegian: "Mønster",
    korean: "Tul",
    belt: "9-gup"
  },
  {
    norwegian: "Utsiden",
    korean: "Bakkat",
    belt: "9-gup"
  },
  {
    norwegian: "Omvendt",
    korean: "Bandaae",
    belt: "9-gup"
  },
  {
    norwegian: "Utover",
    korean: "Bakkuro",
    belt: "9-gup"
  },
  {
    norwegian: "Garderingsblokk",
    korean: "Daebi makgi",
    belt: "9-gup"
  },
  {
    norwegian: "Tre-steg sparring",
    korean: "Sambo matsogi",
    belt: "9-gup"
  },
  {
    norwegian: "Slag",
    korean: "Taerigi",
    belt: "8-gup"
  },
  {
    norwegian: "Svingspark",
    korean: "Dollyo chagi",
    belt: "8-gup"
  },
  {
    norwegian: "Oppadgående",
    korean: "Chookyo",
    belt: "8-gup"
  },
  {
    norwegian: "Tvilling",
    korean: "Sang",
    belt: "8-gup"
  },
  {
    norwegian: "Frisparring",
    korean: "Jayoo matsogi",
    belt: "8-gup"
  },
  {
    norwegian: "Spredningsblokk",
    korean: "Hechyo makgi",
    belt: "7-gup"
  },
  {
    norwegian: "Baksiden av knytteneven",
    korean: "Dung joomuk",
    belt: "7-gup"
  },
  {
    norwegian: "Fingertupp (spydhånd)",
    korean: "Sonkut",
    belt: "7-gup"
  },
  {
    norwegian: "Støt",
    korean: "Tulgi",
    belt: "7-gup"
  },
  {
    norwegian: "Strak",
    korean: "Sun",
    belt: "7-gup"
  },
  {
    norwegian: "Tett stilling",
    korean: "Moa sogi",
    belt: "6-gup"
  },
  {
    norwegian: "Bøyd stilling",
    korean: "Guburyo sogi",
    belt: "6-gup"
  },
  {
    norwegian: "Fiksert stilling",
    korean: "Gojung sogi",
    belt: "6-gup"
  },
  {
    norwegian: "Innover",
    korean: "Anuro",
    belt: "6-gup"
  },
  {
    norwegian: "Nedover",
    korean: "Naeryo",
    belt: "6-gup"
  },
  {
    norwegian: "Sirkelblokk",
    korean: "Dollyomyo makgi",
    belt: "6-gup"
  },
  {
    norwegian: "Bakspark",
    korean: "Dwit cha jirugi",
    belt: "6-gup"
  },
  {
    norwegian: "Bakhæl",
    korean: "Dwichook",
    belt: "6-gup"
  },
  {
    norwegian: "Front albue",
    korean: "Ap palkup",
    belt: "5-gup"
  },
  {
    norwegian: "Dobbel underarmsblokk",
    korean: "Doo palmok makgi",
    belt: "5-gup"
  },
  {
    norwegian: "X-stilling",
    korean: "Kyocha sogi",
    belt: "5-gup"
  },
  {
    norwegian: "Håndflate",
    korean: "Sonbadak",
    belt: "5-gup"
  },
  {
    norwegian: "To-steg sparring",
    korean: "Ibo matsogi",
    belt: "5-gup"
  },
  {
    norwegian: "Omvendt knivhånd",
    korean: "Sonkal dung",
    belt: "4-gup"
  },
  {
    norwegian: "Oppover blokk",
    korean: "Ollyo makgi",
    belt: "4-gup"
  },
  {
    norwegian: "X-knyttneve",
    korean: "Kyocha joomuk",
    belt: "4-gup"
  },
  {
    norwegian: "Tvilling knyttneve",
    korean: "Sang joomuk",
    belt: "4-gup"
  },
  {
    norwegian: "Halvsirkelhånd",
    korean: "Bandal son",
    belt: "4-gup"
  },
  {
    norwegian: "Oppover albue",
    korean: "Wi palkup",
    belt: "4-gup"
  },
  {
    norwegian: "Pressende blokk",
    korean: "Noollo makgi",
    belt: "4-gup"
  },
  {
    norwegian: "U-form blokk",
    korean: "Digutja makgi",
    belt: "4-gup"
  },
  {
    norwegian: "Vertikalt punch",
    korean: "Sewo jirugi",
    belt: "4-gup"
  },
  {
    norwegian: "Oppadvendt punch",
    korean: "Dwijibo jirugi",
    belt: "4-gup"
  },
  {
    norwegian: "Vinkel punch",
    korean: "Kiokja jirugi",
    belt: "4-gup"
  },
  {
    norwegian: "Bakfotstilling",
    korean: "Dwitbal sogi",
    belt: "4-gup"
  },
  {
    norwegian: "Lav stilling",
    korean: "Nachou sogi",
    belt: "4-gup"
  },
  {
    norwegian: "Side front",
    korean: "Yobap",
    belt: "4-gup"
  },
  {
    norwegian: "Oppadvendt spydhånd",
    korean: "Dwijibun sonkut",
    belt: "3-gup"
  },
  {
    norwegian: "Flat spydhånd",
    korean: "Opun sonkut",
    belt: "3-gup"
  },
  {
    norwegian: "W-form blokk",
    korean: "San makgi",
    belt: "3-gup"
  },
  {
    norwegian: "Skyvende blokk",
    korean: "Miro makgi",
    belt: "3-gup"
  },
  {
    norwegian: "Kne",
    korean: "Moorup",
    belt: "3-gup"
  },
  {
    norwegian: "Side bak",
    korean: "Yopdwi",
    belt: "3-gup"
  },
  {
    norwegian: "Flygende",
    korean: "Twimyo",
    belt: "3-gup"
  },
  {
    norwegian: "Hode",
    korean: "Mori",
    belt: "3-gup"
  },
  {
    norwegian: "Ta tak i",
    korean: "Japgi",
    belt: "3-gup"
  },
];
